export { default } from './CompanyDetails';
